import { Group, Text } from '@mantine/core';
import { IconUsers } from '@tabler/icons-react';
import { Auditor } from './types';

interface AuditorDisplayProps {
  auditors: Auditor[];
}

export function AuditorDisplay({ auditors }: AuditorDisplayProps) {
  if (!auditors || auditors.length === 0) {
    return (
      <Group gap={8}>
        <IconUsers size={16} />
        <Text size="sm">Keine Auditoren</Text>
      </Group>
    );
  }

  // Format all auditor names
  // Format all auditor names safely with fallback and trimming
  const auditorNames = auditors
    .map(a => (a?.name?.trim() || a?.email?.trim() || 'Unbekannt'))
    .filter(Boolean);

  const displayText = auditorNames.join(', ');

  return (
    <Group gap={8}>
      <IconUsers size={16} />
      <Text size="sm" lineClamp={1}>
        {displayText}
      </Text>
    </Group>
  );
}
